<app-header></app-header>

<div class="bg-light min-h-screen pb-5 pt-3">
  <div class="container my-5 form-container shadow-sm">
    <div class="form-container">
      <div class="form-header text-center p-4">
        <img src="ExbeBranco.png" alt="Logo Exbe" height="80" class="mb-3">
        <h2 class="mb-1"></h2>
        <p class="text-white-50">Preencha os dados abaixo para cadastrar um novo patrimônio.</p>
      </div>

    <form [formGroup]="patrimonioForm" (ngSubmit)="onSubmit()">

      <div class="form-body p-4">
      <ul class="nav nav-pills nav-fill mb-4" id="pills-tab" role="tablist">
        <li class="nav-item">
          <button class="nav-link active"
                  id="pills-aba1-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-aba1">
            1. Dados do Bem
          </button>
        </li>

        <li class="nav-item">
          <button class="nav-link"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-aba2">
            2. Especificações
          </button>
        </li>

        <li class="nav-item">
          <button class="nav-link"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-aba3">
            3. Condição
          </button>
        </li>
      </ul>

      <div class="tab-content">

        
        <div class="tab-pane fade show active"
             id="pills-aba1"
             formGroupName="dadosBasicos">

          <div class="row g-3">

            <div class="col-md-6">
              <label class="form-label">ID Patrimônio (Opcional)</label>
              <input type="number" class="form-control"
                     formControlName="exbePatrimonioId">
            </div>

            <div class="col-md-6">
              <label class="form-label">Número de Série *</label>
              <input type="string" class="form-control"
                     formControlName="numeroDeSerie">
            </div>

            <div class="col-12">
              <label class="form-label">Observação *</label>
              <textarea rows="3" class="form-control"
                        formControlName="descricao"></textarea>
            </div>

          </div>
        </div>

        
        <div class="tab-pane fade"
             id="pills-aba2"
             formGroupName="modelo">

          <div class="row g-3">

            <div class="col-12">
              <label class="form-label">Modelo *</label>
              <input type="text"
                     class="form-control"
                     formControlName="nome"
                     (blur)="carregarModeloSeExiste()">
            </div>

            <div class="col-md-6" formGroupName="marca">
    <label class="form-label">Marca *</label>
    
    <input type="text" 
           class="form-control"
           formControlName="nome" 
           list="marcasSugestoes"
           (blur)="carregarMarcaSeExiste()"> <datalist id="marcasSugestoes">
        <option *ngFor="let m of marcas" [value]="m.nome"></option>
    </datalist>
</div>

            <div class="col-md-6" formGroupName="categoria">
              <label class="form-label">Categoria *</label>
              <select class="form-select"
                      formControlName="id"
                      (change)="onCategoriaChange()">
                <option [ngValue]="null" disabled>Selecione...</option>
                <option *ngFor="let c of categorias" [ngValue]="c.id">{{ c.nome }}</option>
              </select>
            </div>

          </div>
        </div>

        
        <div class="tab-pane fade"
             id="pills-aba3"
             formGroupName="condicao">

          <div class="row g-3">

            <div class="col-md-6">
      <label class="form-label">Condição *</label>
      <select class="form-select" formControlName="id">
        <option [ngValue]="null" disabled>Selecione...</option>
        <option *ngFor="let condicao of condicoes" [ngValue]="condicao.id">
          {{ condicao.nome }}
        </option>
      </select>
    </div>

          </div>
        </div>

      </div>

      <hr>

      <div class="text-end">
        <button type="submit"
                class="btn btn-success px-4 py-2"
                [disabled]="patrimonioForm.invalid">
          Cadastrar Bem
        </button>
      </div>
</div>
    </form>
  </div>
</div>
